import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';

import { ColourSelectModule } from '../../components/colour-select/colour-select.module';
import { MarkdownEditorModule } from '../../components/markdown-editor/markdown-editor.module';
import { TargetInputModule } from '../../components/target-input/target-input.module';
import { BlockLookComponent } from './block-look.component';
import { ContentSectionsEditorComponent } from './content-sections-editor.component';
import { PlaceholderMenuComponent } from './placeholder-menu.component';

/**
 * The building-block editor on its own (#262), so the content editors (ContentModule) and the Suburbs tool's page
 * template and Page tab (SuburbsModule, which ContentModule imports) can both use it.
 */
@NgModule({
  declarations: [ContentSectionsEditorComponent, BlockLookComponent, PlaceholderMenuComponent],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    DropdownModule,
    InputSwitchModule,
    InputTextModule,
    InputTextareaModule,
    MenuModule,
    MultiSelectModule,
    RippleModule,
    TooltipModule,
    ColourSelectModule,
    MarkdownEditorModule,
    TargetInputModule,
  ],
  exports: [ContentSectionsEditorComponent, PlaceholderMenuComponent],
})
export class ContentSectionsEditorModule {}
